import {
  FoldersNavBreadcrumb as BaseFoldersNavBreadcrumb,
  FoldersNavBreadcrumbItem,
  ALL_DRIVES_KEY,
} from './FoldersNavBreadcrumb';

export const FoldersNavBreadcrumb = {
  Container: BaseFoldersNavBreadcrumb,
  /**
   * Component upon which its children are rendered as item component
   */
  Item: FoldersNavBreadcrumbItem,
};

export { ALL_DRIVES_KEY };

export default FoldersNavBreadcrumb;
